import { friendlyError } from "../../../lib/friendlyError";
import { trpc } from "../../../trpc";
import { TestThenSend } from "../TestThenSend";
import {
  EMAIL_OFF_SENTENCE,
  people,
  SEND_OFFLINE_SENTENCE,
  sendAllSentence,
} from "../sendCopy";
import { BODY_TEXT } from "../ui";
import { useSendFlow } from "../useSendFlow";

/**
 * Hawan, the day before: where to come, when, parking and the entry
 * pass. Groups of six or more on a Full Kund are told they have two
 * Kunds. A second email (the kit and the Kund) follows separately.
 */
export function SeeYouTomorrowPanel({
  eventSlug,
  audienceCount,
  defaultTestEmail,
  senderName,
  alreadySentNote,
}: {
  eventSlug: string;
  audienceCount: number;
  defaultTestEmail: string;
  senderName: string | null;
  alreadySentNote: string | null;
}) {
  const flow = useSendFlow(defaultTestEmail);
  const utils = trpc.useUtils();
  const send = trpc.adminSendHawanSeeYouTomorrow.useMutation();

  const run = (mode: "test" | "all") => {
    send.mutate(
      {
        eventSlug,
        mode,
        testEmail: mode === "test" ? flow.testAddress.trim() : undefined,
        testName: mode === "test" ? (senderName ?? undefined) : undefined,
      },
      {
        onSuccess: (res) => {
          if (res.mode === "test") {
            flow.testSent(
              res.skipped
                ? EMAIL_OFF_SENTENCE
                : `Test sent to ${res.sentTo}. It includes the front-row and two-Kund paragraphs, which only Mukhya Yajman bookings and groups of six or more will get. Read it through, then send.`,
            );
          } else if (res.mode === "all") {
            flow.sendAllDone(
              `${sendAllSentence(res, "No one who booked has an email address, so nothing was sent.")} ${res.twoKundGroups} told about two Kunds, ${res.frontRowGroups} told about the front row.`,
            );
            void utils.adminListEmailSends.invalidate();
          }
        },
        onError: (err) =>
          flow.problem(friendlyError(err, SEND_OFFLINE_SENTENCE)),
      },
    );
  };

  return (
    <>
      <p className={BODY_TEXT}>
        Where to come, when to arrive, parking and the entry pass, and that
        check-in gives them the rest. Groups of six or more on a Full Kund are
        told they have two Kunds. It says a second email with the kit and their
        Kund will follow.
      </p>
      <TestThenSend
        flow={flow}
        emailName="See you tomorrow"
        audience={audienceCount > 0 ? people(audienceCount) : null}
        noAudienceText="No one who booked has an email address yet, so there's no one to send this to."
        busy={send.isPending}
        onSendTest={() => run("test")}
        onSendAll={() => run("all")}
        alreadySentNote={alreadySentNote}
      />
    </>
  );
}
